import { render, staticRenderFns } from "./CapturaDocumentosFotoFrente.vue?vue&type=template&id=6b552786&scoped=true&"
import script from "./CapturaDocumentosFotoFrente.vue?vue&type=script&lang=js&"
export * from "./CapturaDocumentosFotoFrente.vue?vue&type=script&lang=js&"
import style0 from "./CapturaDocumentosFotoFrente.vue?vue&type=style&index=0&id=6b552786&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b552786",
  null
  
)

export default component.exports